export default __webpack_public_path__ + "static/media/img_13.4194d0a5.jpg";